<template>
  <div class="shuttle_bus">
    <el-row>
      <el-col :span="8">
        <el-form-item label="内容">
          <el-input v-model="certifications[index].enumType" placeholder="请输入内容" />
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item label="积分图">
          <picture-icon v-model="certifications[index].images"></picture-icon>
        </el-form-item>
      </el-col>
    </el-row>

    <span v-if="index > 1" @click="subIntegral(index)" class="location_box el-icon-remove-outline" style="font-size: 20px;cursor: pointer"></span>
  </div>
</template>

<script>
import PictureIcon from '@/components/common/picture/pictureIcon'
export default {
  name: 'integrogram',
  components: { PictureIcon },
  props: ['certifications', 'index'],
  data() {
    return {

    }
  },

  methods: {
    //删除一行
    subIntegral (i) {
      this.certifications.splice(i, 1)
    },

    getImgMd5(md5) {
      this.certifications[this.index].images = md5
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .shuttle_bus {
  position: relative;
  .location_box {
    position: absolute;
    top: 8px;
    right: 10px;
  }
}
</style>
